import React from 'react'

import Heading from './Heading';
import Button from './Button';
import ListElement from './ListElement';

export default function ProjectCard(props) {
  return (
    <div className='w-full h-full mb-[1rem]'>
        <Heading>
            <Button ReducedMotion = {props.ReducedMotion} setHover={props.setHover} link={'/projects'}>
                <div className='text-blue keplersemi text-[24px]'>PROJECTS</div>
            </Button>
        </Heading>
        <ListElement ReducedMotion = {props.ReducedMotion} setHover={props.setHover} text={'Lab Research: Parametric Finger'} link='/projects/parametricfinger'/>
        <ListElement ReducedMotion = {props.ReducedMotion} setHover={props.setHover} text={'6DOF Robot Arm'} link='/projects/juniorarm'/>
        <ListElement ReducedMotion = {props.ReducedMotion} setHover={props.setHover} text={'Compound Idler Pulley'} link='/projects/compoundpulley'/>
        <ListElement ReducedMotion = {props.ReducedMotion} setHover={props.setHover} text={'Portfolio Website'} link='/projects/portfolio'/>
        <ListElement ReducedMotion = {props.ReducedMotion} setHover={props.setHover} text={'SEE MORE ...'} link='/projects'/>
    </div>
  )
}
